import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { Typography, Button, Grid, AppBar, Toolbar } from '@material-ui/core'
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos'
import AddWidgets from '../../DashboardComponents/AddWidgets/AddWidgets'
import ReorderWidgets from '../../DashboardComponents/ReorderWidgets/ReorderWidgets'
import {
  setWidgetActive,
  setWidgetActiveLocal,
  selectWidgets,
  // updateWidgets,
  updateWidgetOrder,
} from '../../dashboardSlice'
import { ManageWidgetsMobileStyles } from './ManageWidgetsMobileStyles'
import { ManageTabsMobile } from '../../DashboardComponents/ManageTabsMobile/ManageTabsMobile'
import { FooterButton } from '../../DashboardComponents/ManageWidgets/ManageWidgets'

function ManageWidgetsMobile() {
  const dispatch = useDispatch()
  const classes = ManageWidgetsMobileStyles()
  const history = useHistory()
  const [tabValue, setTabValue] = React.useState(0)
  const [edited, setEdited] = React.useState(false)
  const [search, setSearch] = React.useState('')
  const [selectedWidgets, setSelectedWidgets] = React.useState([])
  const [selectedIndicies, setSelectedIndicies] = React.useState([])
  const [dashboardWidgetsLocal, setDashboardWidgetsLocal] = React.useState([])
  // addableWidgetsRetrieved determines if we have fetched addable widgets yet
  const [addableWidgetsRetrieved, setAddableWidgetsRetrieved] =
    React.useState(false)
  // requireNewAddables determines if we need to refetch addable widgets
  const [requireNewAddables, setRequireNewAddables] = React.useState(false)

  const widgets = useSelector(selectWidgets)

  React.useEffect(() => {
    setDashboardWidgetsLocal(widgets)
  }, [widgets])

  const managePanels = ['Add a widget', 'Reorder Widgets']

  const addWidget = () => {
    setSearch('')
    setTabValue(0)
    let modifiedUserOrder = []
    let selectedWidgetIds = []
    dashboardWidgetsLocal.forEach((user, index) => {
      modifiedUserOrder[index] = { ...user }
    })
    for (let i = 0; i < selectedIndicies.length; i++) {
      dispatch(setWidgetActiveLocal(selectedWidgets[i]))
      modifiedUserOrder = [selectedWidgets[i], ...modifiedUserOrder]
      selectedWidgetIds = [selectedWidgets[i].id, ...selectedWidgetIds]
    }
    dispatch(setWidgetActive(selectedWidgetIds))
    setEdited(false)
    return modifiedUserOrder
  }

  const updateOrder = (newOrder) => {
    dispatch(updateWidgetOrder(newOrder))
    setEdited(false)
  }

  const onSetClick = () => {
    const newOrder = addWidget()
    updateOrder(newOrder)
    history.goBack()
  }

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue)
  }

  const exitPage = () => {
    setDashboardWidgetsLocal(widgets)
    history.goBack()
  }

  return (
    <div className={classes.container}>
      <AppBar className={classes.appBar} position="fixed" elevation={2}>
        <Toolbar className={classes.container}>
          <Grid container justifyContent="flex-start" alignItems="center">
            <Grid item sm={8}>
              <Button onClick={() => exitPage()}>
                <ArrowBackIosIcon className={classes.mobileBackButtonIcon} />
                <Typography className={classes.pageTitle}>
                  Manage Widgets
                </Typography>
              </Button>
            </Grid>
          </Grid>
          <Grid item sm={4}>
            <></>
          </Grid>
        </Toolbar>
      </AppBar>
      <div className={classes.body}>
        <ManageTabsMobile
          tabs={managePanels}
          tabValue={tabValue}
          handleTabChange={handleTabChange}
          tabOne={
            <AddWidgets
              dispatch={dispatch}
              search={search}
              setSearch={setSearch}
              setEdited={setEdited}
              selectedWidgets={selectedWidgets}
              setSelectedWidgets={setSelectedWidgets}
              selectedIndicies={selectedIndicies}
              setSelectedIndicies={setSelectedIndicies}
              addableWidgetsRetrieved={addableWidgetsRetrieved}
              setAddableWidgetsRetrieved={setAddableWidgetsRetrieved}
              requireNewAddables={requireNewAddables}
              setRequireNewAddables={setRequireNewAddables}
            />
          }
          tabTwo={
            <ReorderWidgets
              dispatch={dispatch}
              setEdited={setEdited}
              dashboardWidgetsLocal={dashboardWidgetsLocal}
              setDashboardWidgetsLocal={setDashboardWidgetsLocal}
              updateWidgets={updateWidgetOrder}
              setRequireNewAddables={setRequireNewAddables}
            />
          }
        />
      </div>
      <div className={classes.footerButton}>
        <FooterButton
          onSetClick={onSetClick}
          edited={edited}
          selectedIndicies={selectedIndicies}
          tabValue={tabValue}
          classes={classes}
        />
      </div>
    </div>
  )
}

export default ManageWidgetsMobile
